export const version = "networks/5.5.1";
//# sourceMappingURL=_version.js.map